var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner", attrs: { id: "tab-commonHawb" } },
    [
      _c("div", { staticClass: "form-card-wrapper" }, [
        _c(
          "div",
          {
            staticClass: "form-card section",
            staticStyle: { width: "100%", "padding-bottom": "10px" }
          },
          [
            _c(
              "el-form",
              {
                staticStyle: { height: "100%", width: "1000px" },
                attrs: { "label-width": "90px", "label-position": "left" }
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "space-between"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      { staticClass: "custom", attrs: { label: "MAWB No." } },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-content": "center",
                              "align-items": "center"
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "206px" },
                              attrs: { no: "mbl", disabled: true },
                              model: {
                                value: _vm.job.mbl,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "mbl", $$v)
                                },
                                expression: "job.mbl"
                              }
                            }),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: _vm.$t(
                                    "queryJob.BillOfLadingInformationTracking"
                                  ),
                                  placement: "right"
                                }
                              },
                              [
                                _c("img", {
                                  staticStyle: {
                                    width: "20px",
                                    height: "20px",
                                    display: "list-item",
                                    cursor: "pointer"
                                  },
                                  attrs: {
                                    src: _vm.img.follow,
                                    tip: _vm.$t(
                                      "queryJob.BillOfLadingInformationTracking"
                                    )
                                  },
                                  on: {
                                    click: _vm.showMBLDetailBtnClickHandler
                                  }
                                })
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { staticClass: "custom", attrs: { label: "HAWB No." } },
                      [
                        _c("cargo-input", {
                          staticStyle: { width: "206px" },
                          attrs: {
                            disabled: !_vm.isEditing,
                            no: "hblNbr2",
                            "auto-uppercase": _vm.isUppercase
                          },
                          model: {
                            value: _vm.form.hblNbr2,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "hblNbr2", $$v)
                            },
                            expression: "form.hblNbr2"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "flex-wrap": "nowrap",
                          "min-width": "0",
                          "align-items": "center",
                          "margin-left": "-24px",
                          "margin-top": "-6px"
                        }
                      },
                      [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: ["button_insurance_toInsure"],
                                expression: "['button_insurance_toInsure']"
                              }
                            ],
                            class: !_vm.isEditing
                              ? "el-button el-button--primary el-button--mini"
                              : "el-button el-button--primary el-button--mini is-disabled",
                            staticStyle: {
                              "min-width": "50px!important",
                              "margin-left": "15px",
                              "white-space": "nowrap",
                              "flex-shrink": "0"
                            },
                            attrs: { id: "toInsure", type: "primary" },
                            on: {
                              click: function() {
                                if (!_vm.isEditing) {
                                  _vm.pm.toInsure()
                                }
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Insure")) + " ")]
                        ),
                        _c(
                          "el-button",
                          {
                            staticStyle: {
                              "white-space": "nowrap",
                              "flex-shrink": "0"
                            },
                            attrs: {
                              no: "AntiTerroristFormattedAddress",
                              disabled: !_vm.isEditing,
                              type: "primary"
                            },
                            on: { click: _vm.showAddressFormatDialog }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "SeaExport.AntiTerroristFormattedAddress"
                                )
                              )
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            staticStyle: {
                              "white-space": "nowrap",
                              "flex-shrink": "0"
                            },
                            attrs: {
                              no: "CopyFromOtherBill",
                              disabled: !_vm.isEditing,
                              type: "primary"
                            },
                            on: { click: _vm.copyFromOtherBillHandler }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("SeaExport.CopyFromOtherBill")) +
                                " "
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            staticStyle: {
                              "white-space": "nowrap",
                              "flex-shrink": "0"
                            },
                            attrs: {
                              no: "CodeSearching",
                              disabled: !_vm.isEditing,
                              type: "primary"
                            },
                            on: { click: _vm.popUpAddressWindow }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("SeaExport.CodeSearching")) +
                                " "
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            staticStyle: {
                              "white-space": "nowrap",
                              "flex-shrink": "0"
                            },
                            attrs: {
                              no: "CopyTheMbl",
                              disabled: !_vm.isEditing,
                              type: "primary"
                            },
                            on: {
                              click: function($event) {
                                return _vm.pm.copyMblCargoDoc()
                              }
                            }
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("SeaExport.CopyTheMbl")) + " "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "space-between"
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { "margin-right": "10px" } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: { label: "Shipper" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: { display: "flex", width: "500px" }
                              },
                              [
                                _c("cargo-input", {
                                  staticStyle: { width: "175px" },
                                  attrs: {
                                    disabled: !_vm.isEditing,
                                    no: "shipperCode",
                                    "auto-uppercase":
                                      _vm.notUppercaseShipperConsigneNotify
                                  },
                                  model: {
                                    value: _vm.form.shipperCode,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "shipperCode", $$v)
                                    },
                                    expression: "form.shipperCode"
                                  }
                                }),
                                _c("cargo-company-select", {
                                  staticStyle: {
                                    display: "inline-block",
                                    width: "240px",
                                    "margin-right": "5px"
                                  },
                                  attrs: {
                                    no: "shipperId",
                                    disabled: !_vm.isEditing,
                                    "method-params": {
                                      shipper: true,
                                      active: true
                                    },
                                    "default-value": _vm.form.shipperId || "",
                                    fields: ["englishName"],
                                    "tag-name": "englishName",
                                    placeholder: " "
                                  },
                                  on: {
                                    change: function(data) {
                                      _vm.shipperChangeHandler(data)
                                    }
                                  }
                                }),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-left": "5px" },
                                    attrs: { no: "onClear1", type: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.pm.onClear(1)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")))]
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          { staticClass: "label-none custom " },
                          [
                            _c("cargo-input", {
                              attrs: {
                                disabled: !_vm.isEditing,
                                no: "shipperLine1",
                                maxlength: _vm.maxChars,
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify,
                                "use-read-only": true
                              },
                              on: {
                                change: function($event) {
                                  return _vm.CargoDocUtil.sftAddrChangeWrap(
                                    "shipperLine1",
                                    "shipperLine2",
                                    _vm.maxChars
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showShipperDialog($event)
                                }
                              },
                              model: {
                                value: _vm.form.shipperLine1,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "shipperLine1", $$v)
                                },
                                expression: "form.shipperLine1"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { class: "label-none custom " },
                          [
                            _c("cargo-input", {
                              attrs: {
                                no: "shipperLine2",
                                disabled: !_vm.isEditing,
                                maxlength: _vm.maxChars,
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify,
                                "use-read-only": true
                              },
                              on: {
                                change: function($event) {
                                  return _vm.CargoDocUtil.sftAddrChangeWrap(
                                    "shipperLine2",
                                    "shipperLine3",
                                    _vm.maxChars
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showShipperDialog($event)
                                }
                              },
                              model: {
                                value: _vm.form.shipperLine2,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "shipperLine2", $$v)
                                },
                                expression: "form.shipperLine2"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { class: "label-none custom " },
                          [
                            _c("cargo-input", {
                              attrs: {
                                no: "shipperLine3",
                                disabled: !_vm.isEditing,
                                maxlength: _vm.maxChars,
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify,
                                "use-read-only": true
                              },
                              on: {
                                change: function($event) {
                                  return _vm.CargoDocUtil.sftAddrChangeWrap(
                                    "shipperLine3",
                                    "shipperLine4",
                                    _vm.maxChars
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showShipperDialog($event)
                                }
                              },
                              model: {
                                value: _vm.form.shipperLine3,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "shipperLine3", $$v)
                                },
                                expression: "form.shipperLine3"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { class: "label-none custom " },
                          [
                            _c("cargo-input", {
                              attrs: {
                                no: "shipperLine4",
                                disabled: !_vm.isEditing,
                                maxlength: _vm.maxChars,
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify,
                                "use-read-only": true
                              },
                              on: {
                                change: function($event) {
                                  return _vm.CargoDocUtil.sftAddrChangeWrap(
                                    "shipperLine4",
                                    "shipperLine5",
                                    _vm.maxChars
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showShipperDialog($event)
                                }
                              },
                              model: {
                                value: _vm.form.shipperLine4,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "shipperLine4", $$v)
                                },
                                expression: "form.shipperLine4"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { class: "label-none custom " },
                          [
                            _c("cargo-input", {
                              attrs: {
                                no: "shipperLine5",
                                disabled: !_vm.isEditing,
                                maxlength: _vm.maxChars,
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify,
                                "use-read-only": true
                              },
                              on: {
                                change: function($event) {
                                  return _vm.CargoDocUtil.sftAddrChangeWrap(
                                    "shipperLine5",
                                    "shipperLine6",
                                    _vm.maxChars
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showShipperDialog($event)
                                }
                              },
                              model: {
                                value: _vm.form.shipperLine5,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "shipperLine5", $$v)
                                },
                                expression: "form.shipperLine5"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { class: "label-none custom " },
                          [
                            _c("cargo-input", {
                              attrs: {
                                no: "shipperLine6",
                                disabled: !_vm.isEditing,
                                maxlength: _vm.maxChars,
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify,
                                "use-read-only": true
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showShipperDialog($event)
                                }
                              },
                              model: {
                                value: _vm.form.shipperLine6,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "shipperLine6", $$v)
                                },
                                expression: "form.shipperLine6"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { class: "label-none custom " },
                          [
                            _c("cargo-input", {
                              attrs: {
                                no: "shipperLine7",
                                disabled: !_vm.isEditing,
                                maxlength: _vm.maxChars,
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify,
                                "use-read-only": true
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showShipperDialog($event)
                                }
                              },
                              model: {
                                value: _vm.form.shipperLine7,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "shipperLine7", $$v)
                                },
                                expression: "form.shipperLine7"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "custom",
                            attrs: { label: "Consignee" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: { display: "flex", width: "500px" }
                              },
                              [
                                _c("cargo-input", {
                                  staticStyle: { width: "175px" },
                                  attrs: {
                                    no: "consigneeCode",
                                    disabled: !_vm.isEditing,
                                    "auto-uppercase":
                                      _vm.notUppercaseShipperConsigneNotify
                                  },
                                  model: {
                                    value: _vm.form.consigneeCode,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "consigneeCode", $$v)
                                    },
                                    expression: "form.consigneeCode"
                                  }
                                }),
                                _c("cargo-company-select", {
                                  staticStyle: {
                                    display: "inline-block",
                                    width: "240px",
                                    "margin-right": "5px"
                                  },
                                  attrs: {
                                    no: "consigneeId",
                                    disabled: !_vm.isEditing,
                                    "method-params": {
                                      consignee: true,
                                      active: true
                                    },
                                    "default-value": _vm.form.consigneeId || "",
                                    fields: ["englishName"],
                                    "tag-name": "englishName",
                                    placeholder: " "
                                  },
                                  on: {
                                    change: function(data) {
                                      _vm.consigneeChangeHandler(data)
                                    }
                                  }
                                }),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-left": "5px" },
                                    attrs: { no: "onClear2", type: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.pm.onClear(2)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")))]
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          { class: "label-none custom " },
                          [
                            _c("cargo-input", {
                              attrs: {
                                disabled: !_vm.isEditing,
                                no: "consigneeLine1",
                                maxlength: _vm.maxChars,
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify,
                                "use-read-only": true
                              },
                              on: {
                                change: function($event) {
                                  return _vm.CargoDocUtil.sftAddrChangeWrap(
                                    "consigneeLine1",
                                    "consigneeLine2",
                                    _vm.maxChars
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showConsigneeDialog($event)
                                }
                              },
                              model: {
                                value: _vm.form.consigneeLine1,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "consigneeLine1", $$v)
                                },
                                expression: "form.consigneeLine1"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { class: "label-none custom " },
                          [
                            _c("cargo-input", {
                              attrs: {
                                disabled: !_vm.isEditing,
                                no: "consigneeLine2",
                                maxlength: _vm.maxChars,
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify,
                                "use-read-only": true
                              },
                              on: {
                                change: function($event) {
                                  return _vm.CargoDocUtil.sftAddrChangeWrap(
                                    "consigneeLine2",
                                    "consigneeLine3",
                                    _vm.maxChars
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showConsigneeDialog($event)
                                }
                              },
                              model: {
                                value: _vm.form.consigneeLine2,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "consigneeLine2", $$v)
                                },
                                expression: "form.consigneeLine2"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { class: "label-none custom " },
                          [
                            _c("cargo-input", {
                              attrs: {
                                disabled: !_vm.isEditing,
                                no: "consigneeLine3",
                                maxlength: _vm.maxChars,
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify,
                                "use-read-only": true
                              },
                              on: {
                                change: function($event) {
                                  return _vm.CargoDocUtil.sftAddrChangeWrap(
                                    "consigneeLine3",
                                    "consigneeLine4",
                                    _vm.maxChars
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showConsigneeDialog($event)
                                }
                              },
                              model: {
                                value: _vm.form.consigneeLine3,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "consigneeLine3", $$v)
                                },
                                expression: "form.consigneeLine3"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { class: "label-none custom " },
                          [
                            _c("cargo-input", {
                              attrs: {
                                disabled: !_vm.isEditing,
                                no: "consigneeLine4",
                                maxlength: _vm.maxChars,
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify,
                                "use-read-only": true
                              },
                              on: {
                                change: function($event) {
                                  return _vm.CargoDocUtil.sftAddrChangeWrap(
                                    "consigneeLine4",
                                    "consigneeLine5",
                                    _vm.maxChars
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showConsigneeDialog($event)
                                }
                              },
                              model: {
                                value: _vm.form.consigneeLine4,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "consigneeLine4", $$v)
                                },
                                expression: "form.consigneeLine4"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { class: "label-none custom " },
                          [
                            _c("cargo-input", {
                              attrs: {
                                disabled: !_vm.isEditing,
                                no: "consigneeLine5",
                                maxlength: _vm.maxChars,
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify,
                                "use-read-only": true
                              },
                              on: {
                                change: function($event) {
                                  return _vm.CargoDocUtil.sftAddrChangeWrap(
                                    "consigneeLine5",
                                    "consigneeLine6",
                                    _vm.maxChars
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showConsigneeDialog($event)
                                }
                              },
                              model: {
                                value: _vm.form.consigneeLine5,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "consigneeLine5", $$v)
                                },
                                expression: "form.consigneeLine5"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { class: "label-none custom " },
                          [
                            _c("cargo-input", {
                              attrs: {
                                disabled: !_vm.isEditing,
                                no: "consigneeLine6",
                                maxlength: _vm.maxChars,
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify,
                                "use-read-only": true
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showConsigneeDialog($event)
                                }
                              },
                              model: {
                                value: _vm.form.consigneeLine6,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "consigneeLine6", $$v)
                                },
                                expression: "form.consigneeLine6"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { class: "label-none custom " },
                          [
                            _c("cargo-input", {
                              attrs: {
                                disabled: !_vm.isEditing,
                                no: "consigneeLine7",
                                maxlength: _vm.maxChars,
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify,
                                "use-read-only": true
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showConsigneeDialog($event)
                                }
                              },
                              model: {
                                value: _vm.form.consigneeLine7,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "consigneeLine7", $$v)
                                },
                                expression: "form.consigneeLine7"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "flex-direction": "column"
                            }
                          },
                          [
                            _c("span", [_vm._v("Airport of Departure")]),
                            _c("cargo-input", {
                              attrs: {
                                disabled: !_vm.isEditing,
                                no: "airportOfDeparture",
                                "auto-uppercase": _vm.isUppercase
                              },
                              model: {
                                value: _vm.form.airportOfDeparture,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "airportOfDeparture", $$v)
                                },
                                expression: "form.airportOfDeparture"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      [
                        _c(
                          "el-form-item",
                          { staticClass: "custom", attrs: { label: "Notify" } },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: { display: "flex", width: "520px" }
                              },
                              [
                                _c("cargo-input", {
                                  staticStyle: { width: "175px" },
                                  attrs: {
                                    disabled: !_vm.isEditing,
                                    no: "notifyCode",
                                    "auto-uppercase":
                                      _vm.notUppercaseShipperConsigneNotify
                                  },
                                  model: {
                                    value: _vm.form.notifyCode,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "notifyCode", $$v)
                                    },
                                    expression: "form.notifyCode"
                                  }
                                }),
                                _c("cargo-company-select", {
                                  staticStyle: {
                                    display: "inline-block",
                                    width: "240px",
                                    "margin-right": "5px"
                                  },
                                  attrs: {
                                    no: "notifyId",
                                    disabled: !_vm.isEditing,
                                    "method-params": {
                                      notify: true,
                                      active: true
                                    },
                                    "default-value": _vm.form.notifyId || "",
                                    fields: ["englishName"],
                                    "tag-name": "englishName",
                                    placeholder: " "
                                  },
                                  on: {
                                    change: function(data) {
                                      _vm.notifyChangeHandler(data)
                                    }
                                  }
                                }),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-left": "5px" },
                                    attrs: { no: "onClear3", type: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.pm.onClear(3)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Reset")))]
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          { class: "label-none custom " },
                          [
                            _c("cargo-input", {
                              attrs: {
                                disabled: !_vm.isEditing,
                                no: "notifyLine1",
                                maxlength: _vm.maxChars,
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify,
                                "use-read-only": true
                              },
                              on: {
                                change: function($event) {
                                  return _vm.CargoDocUtil.sftAddrChangeWrap(
                                    "notifyLine1",
                                    "notifyLine2",
                                    _vm.maxChars
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showNotifyDialog($event)
                                }
                              },
                              model: {
                                value: _vm.form.notifyLine1,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "notifyLine1", $$v)
                                },
                                expression: "form.notifyLine1"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { class: "label-none custom " },
                          [
                            _c("cargo-input", {
                              attrs: {
                                disabled: !_vm.isEditing,
                                no: "notifyLine2",
                                maxlength: _vm.maxChars,
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify,
                                "use-read-only": true
                              },
                              on: {
                                change: function($event) {
                                  return _vm.CargoDocUtil.sftAddrChangeWrap(
                                    "notifyLine2",
                                    "notifyLine3",
                                    _vm.maxChars
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showNotifyDialog($event)
                                }
                              },
                              model: {
                                value: _vm.form.notifyLine2,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "notifyLine2", $$v)
                                },
                                expression: "form.notifyLine2"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { class: "label-none custom " },
                          [
                            _c("cargo-input", {
                              attrs: {
                                disabled: !_vm.isEditing,
                                no: "notifyLine3",
                                maxlength: _vm.maxChars,
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify,
                                "use-read-only": true
                              },
                              on: {
                                change: function($event) {
                                  return _vm.CargoDocUtil.sftAddrChangeWrap(
                                    "notifyLine3",
                                    "notifyLine4",
                                    _vm.maxChars
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showNotifyDialog($event)
                                }
                              },
                              model: {
                                value: _vm.form.notifyLine3,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "notifyLine3", $$v)
                                },
                                expression: "form.notifyLine3"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { class: "label-none custom " },
                          [
                            _c("cargo-input", {
                              attrs: {
                                disabled: !_vm.isEditing,
                                no: "notifyLine4",
                                maxlength: _vm.maxChars,
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify,
                                "use-read-only": true
                              },
                              on: {
                                change: function($event) {
                                  return _vm.CargoDocUtil.sftAddrChangeWrap(
                                    "notifyLine4",
                                    "notifyLine5",
                                    _vm.maxChars
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showNotifyDialog($event)
                                }
                              },
                              model: {
                                value: _vm.form.notifyLine4,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "notifyLine4", $$v)
                                },
                                expression: "form.notifyLine4"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { class: "label-none custom " },
                          [
                            _c("cargo-input", {
                              attrs: {
                                disabled: !_vm.isEditing,
                                no: "notifyLine5",
                                maxlength: _vm.maxChars,
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify,
                                "use-read-only": true
                              },
                              on: {
                                change: function($event) {
                                  return _vm.CargoDocUtil.sftAddrChangeWrap(
                                    "notifyLine5",
                                    "notifyLine6",
                                    _vm.maxChars
                                  )
                                }
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showNotifyDialog($event)
                                }
                              },
                              model: {
                                value: _vm.form.notifyLine5,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "notifyLine5", $$v)
                                },
                                expression: "form.notifyLine5"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { class: "label-none custom " },
                          [
                            _c("cargo-input", {
                              attrs: {
                                disabled: !_vm.isEditing,
                                no: "notifyLine6",
                                maxlength: _vm.maxChars,
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify,
                                "use-read-only": true
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showNotifyDialog($event)
                                }
                              },
                              model: {
                                value: _vm.form.notifyLine6,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "notifyLine6", $$v)
                                },
                                expression: "form.notifyLine6"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { class: "label-none custom " },
                          [
                            _c("cargo-input", {
                              attrs: {
                                disabled: !_vm.isEditing,
                                no: "notifyLine7",
                                maxlength: _vm.maxChars,
                                "auto-uppercase":
                                  _vm.notUppercaseShipperConsigneNotify,
                                "use-read-only": true
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showNotifyDialog($event)
                                }
                              },
                              model: {
                                value: _vm.form.notifyLine7,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "notifyLine7", $$v)
                                },
                                expression: "form.notifyLine7"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "flex-direction": "column"
                            }
                          },
                          [
                            _c("span", [_vm._v("Issued By")]),
                            _c("cargo-rich-textarea", {
                              staticStyle: { height: "110px" },
                              attrs: {
                                disabled: !_vm.isEditing,
                                no: "issuedBy",
                                "text-chars": 0,
                                "auto-uppercase": true,
                                "warning-count": -1
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showAdvanceTextDialog(
                                    "Issued By",
                                    _vm.form.issuedBy,
                                    function(val) {
                                      _vm.form.issuedBy = val
                                    }
                                  )
                                }
                              },
                              model: {
                                value: _vm.form.issuedBy,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "issuedBy", $$v)
                                },
                                expression: "form.issuedBy"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "flex-direction": "column"
                            }
                          },
                          [
                            _c("span", [_vm._v("Accounting Information")]),
                            _c("cargo-rich-textarea", {
                              staticStyle: { height: "110px" },
                              attrs: {
                                disabled: !_vm.isEditing,
                                no: "accountingInfo",
                                "text-chars": 0,
                                "auto-uppercase": true,
                                "warning-count": -1
                              },
                              nativeOn: {
                                dblclick: function($event) {
                                  return _vm.showAdvanceTextDialog(
                                    "Accounting Information",
                                    _vm.form.accountingInfo,
                                    function(val) {
                                      _vm.form.accountingInfo = val
                                    }
                                  )
                                }
                              },
                              model: {
                                value: _vm.form.accountingInfo,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "accountingInfo", $$v)
                                },
                                expression: "form.accountingInfo"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between",
                              "margin-top": "39px"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "margin-right": "2px"
                                }
                              },
                              [
                                _c("span", [_vm._v("Freight Term")]),
                                _c("cargo-input", {
                                  staticStyle: { width: "190px" },
                                  attrs: {
                                    no: "freightTerm",
                                    "auto-uppercase": _vm.isUppercase,
                                    disabled: true
                                  },
                                  model: {
                                    value: _vm.freightTerm,
                                    callback: function($$v) {
                                      _vm.freightTerm = $$v
                                    },
                                    expression: "freightTerm"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.PiecesType2"))
                                  )
                                ]),
                                _c("el-input-number", {
                                  staticStyle: {
                                    width: "130px",
                                    "margin-right": "5px"
                                  },
                                  attrs: {
                                    value: _vm.form.insideQuantity || undefined,
                                    no: "insideQuantity",
                                    "controls-position": "right",
                                    controls: false,
                                    min: 0,
                                    max: 999999999999,
                                    disabled: !_vm.isEditing
                                  },
                                  on: {
                                    input: function(val) {
                                      _vm.form.insideQuantity = val
                                    }
                                  }
                                }),
                                _c("cargo-input", {
                                  staticStyle: { width: "115px" },
                                  attrs: {
                                    disabled: !_vm.isEditing,
                                    no: "insidePacking",
                                    "auto-uppercase": _vm.isUppercase
                                  },
                                  model: {
                                    value: _vm.form.insidePacking,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "insidePacking", $$v)
                                    },
                                    expression: "form.insidePacking"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "space-between"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "flex-direction": "column",
                          "margin-right": "2px"
                        }
                      },
                      [
                        _c("span", [_vm._v("To")]),
                        _c("cargo-input", {
                          attrs: {
                            disabled: !_vm.isEditing,
                            no: "podTo",
                            "auto-uppercase": _vm.isUppercase
                          },
                          model: {
                            value: _vm.form.podTo,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "podTo", $$v)
                            },
                            expression: "form.podTo"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "flex-direction": "column",
                          width: "300px",
                          "margin-right": "2px"
                        }
                      },
                      [
                        _c("span", [_vm._v("By First Carrier")]),
                        _c("cargo-input", {
                          attrs: {
                            disabled: !_vm.isEditing,
                            no: "carrierBy",
                            "auto-uppercase": _vm.isUppercase
                          },
                          model: {
                            value: _vm.form.carrierBy,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "carrierBy", $$v)
                            },
                            expression: "form.carrierBy"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "flex-direction": "column",
                          "margin-right": "2px"
                        }
                      },
                      [
                        _c("span", [_vm._v("To")]),
                        _c("cargo-input", {
                          attrs: {
                            disabled: !_vm.isEditing,
                            no: "podTo1",
                            "auto-uppercase": _vm.isUppercase
                          },
                          model: {
                            value: _vm.form.podTo1,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "podTo1", $$v)
                            },
                            expression: "form.podTo1"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "flex-direction": "column",
                          "margin-right": "2px"
                        }
                      },
                      [
                        _c("span", [_vm._v("By")]),
                        _c("cargo-input", {
                          attrs: {
                            disabled: !_vm.isEditing,
                            no: "carrierBy1",
                            "auto-uppercase": _vm.isUppercase
                          },
                          model: {
                            value: _vm.form.carrierBy1,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "carrierBy1", $$v)
                            },
                            expression: "form.carrierBy1"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "flex-direction": "column",
                          "margin-right": "2px"
                        }
                      },
                      [
                        _c("span", [_vm._v("To")]),
                        _c("cargo-input", {
                          attrs: {
                            disabled: !_vm.isEditing,
                            no: "podTo2",
                            "auto-uppercase": _vm.isUppercase
                          },
                          model: {
                            value: _vm.form.podTo2,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "podTo2", $$v)
                            },
                            expression: "form.podTo2"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "flex-direction": "column",
                          "margin-right": "2px"
                        }
                      },
                      [
                        _c("span", [_vm._v("By")]),
                        _c("cargo-input", {
                          attrs: {
                            disabled: !_vm.isEditing,
                            no: "carrierBy2",
                            "auto-uppercase": _vm.isUppercase
                          },
                          model: {
                            value: _vm.form.carrierBy2,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "carrierBy2", $$v)
                            },
                            expression: "form.carrierBy2"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "flex-direction": "column",
                          "margin-right": "2px"
                        }
                      },
                      [
                        _c("span", [_vm._v("Currency")]),
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "currency",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Currency,
                            disabled: !_vm.isEditing,
                            filterable: "",
                            clearable: false,
                            "static-options": _vm.currencyList,
                            "default-value": _vm.form.currency
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.form.currency = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "flex-direction": "column",
                          width: "300px",
                          "margin-right": "2px"
                        }
                      },
                      [
                        _c("span", [_vm._v("WT/VAL")]),
                        _c(
                          "el-select",
                          {
                            attrs: { disabled: !_vm.isEditing, no: "wtVal" },
                            on: {
                              change: function($event) {
                                return _vm.cpChangeHandler("wtVal")
                              }
                            },
                            model: {
                              value: _vm.form.wtVal,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "wtVal", $$v)
                              },
                              expression: "form.wtVal"
                            }
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "PP", value: "PP" }
                            }),
                            _c("el-option", {
                              attrs: { label: "CC", value: "CC" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "flex-direction": "column",
                          width: "300px",
                          "margin-right": "2px"
                        }
                      },
                      [
                        _c("span", [_vm._v("Other")]),
                        _c(
                          "el-select",
                          {
                            attrs: { disabled: !_vm.isEditing, no: "other" },
                            on: {
                              change: function($event) {
                                return _vm.cpChangeHandler("other")
                              }
                            },
                            model: {
                              value: _vm.form.other,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "other", $$v)
                              },
                              expression: "form.other"
                            }
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "PP", value: "PP" }
                            }),
                            _c("el-option", {
                              attrs: { label: "CC", value: "CC" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "flex-direction": "column",
                          width: "300px",
                          "margin-right": "2px"
                        }
                      },
                      [
                        _c("span", [_vm._v("D.V.Carrier")]),
                        _c("cargo-input", {
                          attrs: {
                            disabled: !_vm.isEditing,
                            no: "carriageDv",
                            "auto-uppercase": _vm.isUppercase
                          },
                          model: {
                            value: _vm.form.carriageDv,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "carriageDv", $$v)
                            },
                            expression: "form.carriageDv"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "flex-direction": "column",
                          width: "300px",
                          "margin-right": "2px"
                        }
                      },
                      [
                        _c("span", [_vm._v("D.V. for Customs")]),
                        _c("cargo-input", {
                          attrs: {
                            disabled: !_vm.isEditing,
                            no: "dvForCustoms",
                            "auto-uppercase": _vm.isUppercase
                          },
                          model: {
                            value: _vm.form.dvForCustoms,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "dvForCustoms", $$v)
                            },
                            expression: "form.dvForCustoms"
                          }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      width: "65%",
                      display: "flex",
                      "justify-content": "flex-start"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "flex-direction": "column",
                          flex: "1",
                          "margin-right": "10px"
                        }
                      },
                      [
                        _c("span", [_vm._v("Airport of Destination")]),
                        _c("cargo-input", {
                          attrs: {
                            disabled: !_vm.isEditing,
                            no: "airportOfDestination",
                            "auto-uppercase": _vm.isUppercase
                          },
                          model: {
                            value: _vm.form.airportOfDestination,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "airportOfDestination", $$v)
                            },
                            expression: "form.airportOfDestination"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "flex-direction": "column",
                          "margin-right": "10px"
                        }
                      },
                      [
                        _c("span", [_vm._v("Flight/Date")]),
                        _c("el-date-picker", {
                          attrs: {
                            disabled: true,
                            no: "etd",
                            clearable: "",
                            type: "datetime",
                            format: "yyyy-MM-dd",
                            "value-format": "yyyy-MM-dd"
                          },
                          model: {
                            value: _vm.job.etd,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "etd", $$v)
                            },
                            expression: "job.etd"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "flex-direction": "column",
                          "margin-right": "10px"
                        }
                      },
                      [
                        _c("span", [_vm._v("Amount of insurance")]),
                        _c("cargo-input", {
                          attrs: {
                            disabled: !_vm.isEditing,
                            no: "insuredAmount",
                            "auto-uppercase": _vm.isUppercase
                          },
                          model: {
                            value: _vm.form.insuredAmount,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "insuredAmount", $$v)
                            },
                            expression: "form.insuredAmount"
                          }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _c("div", [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "column"
                      }
                    },
                    [
                      _c("span", [_vm._v("Handling Info")]),
                      _c("cargo-rich-textarea", {
                        staticStyle: { height: "110px" },
                        attrs: {
                          disabled: !_vm.isEditing,
                          no: "handingInfo",
                          "text-chars": 0,
                          "auto-uppercase": true,
                          "warning-count": -1
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            return _vm.showAdvanceTextDialog(
                              "Handling Information",
                              _vm.form.handingInfo,
                              function(val) {
                                _vm.form.handingInfo = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.form.handingInfo,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "handingInfo", $$v)
                          },
                          expression: "form.handingInfo"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _c("hawb-part1", {
                  ref: "part1",
                  staticStyle: { width: "100%" },
                  attrs: {
                    "cargo-doc": _vm.form,
                    job: _vm.job,
                    action: _vm.action,
                    "is-uppercase-by-config": _vm.isUppercaseByConfig
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "append-to-body": true
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            staticStyle: { height: "320px" },
            attrs: { disabled: !_vm.isEditing },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEditing,
                      expression: "isEditing"
                    }
                  ],
                  attrs: { no: "confirm", type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "close" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("bill-address-dialog", {
        attrs: {
          visible: _vm.billAddressDialog.visible,
          job: _vm.billAddressDialog.job,
          params: _vm.billAddressDialog.params
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.billAddressDialog, "visible", $event)
          },
          callback: _vm.codeSearchCallback
        }
      }),
      _c("address-format-dialog", {
        attrs: {
          visible: _vm.addressFormatDialog.visible,
          job: _vm.addressFormatDialog.job,
          params: _vm.addressFormatDialog.params
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.addressFormatDialog, "visible", $event)
          }
        }
      }),
      _c("copy-from-other-bill-dialog", {
        attrs: {
          "doc-type": _vm.copyFromOtherBillDialog.docType,
          visible: _vm.copyFromOtherBillDialog.visible
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.copyFromOtherBillDialog, "visible", $event)
          },
          selected: _vm.transcribeEnterHandler
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }